// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../Members/MemberForm.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.minor-member-form-container {
  padding: 0;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.form-tabs {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 1.5rem;
}

.form-tab {
  padding: 8px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.9rem;
  color: #6c757d;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.form-tab:hover { color: #495057; background: #f8f9fa; }

.form-tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  font-weight: 600;
}

.form-body {
  min-height: 320px;
}

.form-section { padding: 0 4px; }

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 6px;
  margin-bottom: 1rem;
}

.section-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.health-question {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 12px;
}

.health-check-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin: 0;
  font-weight: 500;
}

.health-check-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.worship-id-input {
  font-family: 'Courier New', monospace;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 3px;
  text-align: center;
}

.family-table td { vertical-align: middle; }

/* ── Family member worship-code autocomplete ──────────────────────────── */
.family-worship-input { min-width: 120px; }

.fam-searching {
  font-size: 11px;
  color: #6b7280;
  padding: 2px 4px;
}

.fam-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  z-index: 300;
  max-height: 220px;
  overflow-y: auto;
}

.fam-suggestion-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 13px;
}
.fam-suggestion-item:hover { background: #f0f9ff; }

.fam-type-badge {
  color: #fff;
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.fam-code {
  font-family: 'Courier New', monospace;
  font-weight: 700;
  font-size: 12px;
  color: #374151;
  min-width: 52px;
}

.fam-name {
  color: #111827;
  flex: 1 1;
}

.fam-no-results {
  font-size: 12px;
  color: #9ca3af;
  padding: 4px 8px;
  font-style: italic;
}

.form-control-static {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 4px 0;
}

.badge-lg {
  font-size: 0.9rem;
  padding: 5px 12px;
  border-radius: 4px;
}

.badge-purple {
  background-color: #7c3aed;
  color: #fff;
}

.badge-info {
  background-color: #0ea5e9;
  color: #fff;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 1.5rem;
  border-top: 1px solid #dee2e6;
  margin-top: 1.5rem;
}

label.required::after {
  content: ' *';
  color: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./src/components/MinorMembers/MinorMemberForm.css"],"names":[],"mappings":"AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB,cAAc,EAAE,mBAAmB,EAAE;;AAEvD;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB,cAAc,EAAE;;AAEhC;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mBAAmB,sBAAsB,EAAE;;AAE3C,4EAA4E;AAC5E,wBAAwB,gBAAgB,EAAE;;AAE1C;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB","sourcesContent":["@import '../Members/MemberForm.css';\n\n.minor-member-form-container {\n  padding: 0;\n}\n\n.form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.form-tabs {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  border-bottom: 2px solid #dee2e6;\n  margin-bottom: 1.5rem;\n}\n\n.form-tab {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: #6c757d;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.form-tab:hover { color: #495057; background: #f8f9fa; }\n\n.form-tab.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  font-weight: 600;\n}\n\n.form-body {\n  min-height: 320px;\n}\n\n.form-section { padding: 0 4px; }\n\n.section-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  padding-bottom: 6px;\n  margin-bottom: 1rem;\n}\n\n.section-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.health-question {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.health-check-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  margin: 0;\n  font-weight: 500;\n}\n\n.health-check-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.worship-id-input {\n  font-family: 'Courier New', monospace;\n  font-weight: 700;\n  font-size: 1.1rem;\n  letter-spacing: 3px;\n  text-align: center;\n}\n\n.family-table td { vertical-align: middle; }\n\n/* ── Family member worship-code autocomplete ──────────────────────────── */\n.family-worship-input { min-width: 120px; }\n\n.fam-searching {\n  font-size: 11px;\n  color: #6b7280;\n  padding: 2px 4px;\n}\n\n.fam-suggestions {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0,0,0,.12);\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  z-index: 300;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.fam-suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: 13px;\n}\n.fam-suggestion-item:hover { background: #f0f9ff; }\n\n.fam-type-badge {\n  color: #fff;\n  border-radius: 3px;\n  padding: 1px 5px;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.fam-code {\n  font-family: 'Courier New', monospace;\n  font-weight: 700;\n  font-size: 12px;\n  color: #374151;\n  min-width: 52px;\n}\n\n.fam-name {\n  color: #111827;\n  flex: 1;\n}\n\n.fam-no-results {\n  font-size: 12px;\n  color: #9ca3af;\n  padding: 4px 8px;\n  font-style: italic;\n}\n\n.form-control-static {\n  display: flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 4px 0;\n}\n\n.badge-lg {\n  font-size: 0.9rem;\n  padding: 5px 12px;\n  border-radius: 4px;\n}\n\n.badge-purple {\n  background-color: #7c3aed;\n  color: #fff;\n}\n\n.badge-info {\n  background-color: #0ea5e9;\n  color: #fff;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding-top: 1.5rem;\n  border-top: 1px solid #dee2e6;\n  margin-top: 1.5rem;\n}\n\nlabel.required::after {\n  content: ' *';\n  color: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
